export default __webpack_public_path__ + "static/media/PlusIcon.2f47e1b2.svg";